<template>
  <div style="width: 90vw">
    <el-container class="contain-6" style="padding: 25px 25px">
      <div class="bbb">
        <el-button type="primary" @click="handleBatchSave" size="mini" style="margin-bottom: 20px">
          批量保存（已修改 {{ changedCount }} 处）
        </el-button>
        <el-header style="display: flex;height: 40px;">
          <span class="style-title">项目名称:</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>

          <span class="style-title">日期:</span>

          <el-date-picker
              v-model="value2"
              type="daterange"
              align="right"
              unlink-panels
              style="margin-left: 5px;margin-top: 9px;height:28px;width: 280px;align-items: center;display: flex"
              size="mini"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions3">
          </el-date-picker>

          <span class="style-title">预估计算日期:</span>
          <el-date-picker
              v-model="value5"

              unlink-panels
              style="margin-left: 5px;margin-top: 9px;height:28px;width: 180px;align-items: center;display: flex"
              size="mini"
              value-format="yyyy-MM-dd"
              align="right"
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptions">
          </el-date-picker>
          <!--          <el-select v-model="yType" clearable placeholder="请选择预估方式"   v-show="activeName==='4'"-->
          <!--                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex" size="mini">-->
          <!--            <el-option-->
          <!--                v-for="item in optionsYType"-->
          <!--                :key="item.value"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>
        </el-header>
        <el-table
            :data="tableData"
            style="width: 98%"
            :v-loading="loading"
            max-height="80vh"
            height="79vh"
            size="mini"
            :cell-class-name="getCellClassName"
        >
          <el-table-column prop="uploadDate" label="日期" width="160">
            <template #default="{ row }">
              <span>{{ row.uploadDate }}</span>

            </template>
          </el-table-column>
          <!-- 年龄列 -->
          <el-table-column prop="gameName" label="游戏名" width="160">
            <template #default="{ row, $index }">
              <div class="editable-cell"
                   @click="startEditing($index, 'gameName', row.gameName)"
              >
                <el-input
                    v-if="editing.rowIndex === $index && editing.column === 'gameName'"
                    ref="gameNameInput"
                    v-model.number="editing.tempValue"
                    size="mini"
                    @blur="handleSaveEdit"
                    @keyup.enter.native="handleSaveEdit"
                    @keyup.esc.native="handleCancelEdit"
                />
                <span v-else>{{ row.gameName }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              :prop="'roi'+item"
              :label="item+'日倍率'"
              width="160"
              :key="index"
              v-for="(item,index) in items">
            <template #default="{ row, $index }">
              <div class="editable-cell"
                   @click="startEditing($index, 'roi'+item, row['roi'+item])">
                <el-input
                    v-if="editing.rowIndex === $index && editing.column === ('roi'+item)"
                    :ref="'roi'+item+'Input'"
                    v-model.number="editing.tempValue"
                    size="mini"
                    @blur="handleSaveEdit"
                    @keyup.enter.native="handleSaveEdit"
                    @keyup.esc.native="handleCancelEdit"
                />
                <span v-else>{{ row['roi' + item] }}</span>
              </div>
            </template>
          </el-table-column>


        </el-table>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      valueGame: '',
      items: [3, 7, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150],
      optionsGame: [],
      pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      value2: [],
      value5: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      tableData: [],
      originalData: [], // 原始数据副本
      editing: {
        rowIndex: -1,
        column: '',
        originalValue: null,
        tempValue: null
      }
    };
  },
  computed: {
    // 计算修改数量
    changedCount() {
      if (this.tableData.length > 0) {
        console.log(this.tableData)
        console.log(this.originalData)
        return this.tableData.reduce((count, row, index) => {
          const original = this.originalData[index];
          return count + (row.uploadDate !== original.uploadDate
              || row.gameName !== original.gameName
              || row.roi3 !== original.roi3
              || row.roi7 !== original.roi7
              || row.roi15 !== original.roi15
              || row.roi30 !== original.roi30
              || row.roi45 !== original.roi45
              || row.roi60 !== original.roi60
              || row.roi75 !== original.roi75
              || row.roi90 !== original.roi90
              || row.roi105 !== original.roi105
              || row.roi120 !== original.roi120
              || row.roi135 !== original.roi135
              || row.roi150 !== original.roi150);
        }, 0);
      }

      return 0
    }
  },
  created() {
    // 初始化时克隆原始数据
    this.originalData = JSON.parse(JSON.stringify(this.tableData));
  },
  mounted: function () {
    this.height = window.innerHeight;
    this.findGame()
    this.init(false)

  },
  methods: {
    // 开始编辑（记录原始值）
    startEditing(index, column, value) {

      console.log(index, column, value)
      this.editing = {
        rowIndex: index,
        column,
        originalValue: value,
        tempValue: value
      };
      this.$nextTick(() => {
        const refName = `${column}Input`;

        this.$refs[refName]?.focus();
      });
    }, findGame() {

      this.$axios
          .get('/toufang/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },init(flag){

      if (flag) {

        console.log("手动选条件")
        console.log(JSON.parse(this.tableData))
        localStorage.setItem("Test", JSON.stringify({
          name: this.valueGame,
          date: this.value2,
          date2: this.value5,

        }))

      } else {

        if (localStorage.getItem("Test") != null) {

          console.log("自动刷")

          this.valueGame = JSON.parse(localStorage.getItem("Test")).name

          this.value2 = JSON.parse(localStorage.getItem("Test")).date

          this.value5 = JSON.parse(localStorage.getItem("Test")).date2


        }
      }

    }, search(flag) {
      if (flag) {

        console.log("手动选条件")

        localStorage.setItem("Test", JSON.stringify({
          name: this.valueGame,
          date: this.value2,
          date2: this.value5,

        }))

      } else {

        if (localStorage.getItem("Test") != null) {

          console.log("自动刷")

          this.valueGame = JSON.parse(localStorage.getItem("Test")).name

          this.value2 = JSON.parse(localStorage.getItem("Test")).date

          this.value5 = JSON.parse(localStorage.getItem("Test")).date2

        }
      }


      this.maxHeight = window.innerHeight - 250;
        this.loading = true

        this.$axios
            .post('/toufang/data/findYu', {
              start: this.value2 == null ? '' : this.value2[0],
              cname: this.valueGame == null ? '' : this.valueGame,
              currentPage: this.currentPage4 == null ? 1 : this.currentPage4,
              end: this.value2 == null ? '' : this.value2[1],
              date: this.value5 == null ? '' : this.value5,
              type: this.yType == null ? '' : this.yType
            })
            .then(successResponse => {
              this.tableData = JSON.parse(JSON.stringify(successResponse.data.data));
              this.originalData = JSON.parse(JSON.stringify(successResponse.data.data));


              this.loading = false
            })


    },

    // 保存单个单元格修改
    handleSaveEdit() {
      if (this.editing.rowIndex > -1) {
        const {rowIndex, column, tempValue} = this.editing;
        this.tableData[rowIndex][column] = tempValue;
      }
      this.editing = {rowIndex: -1, column: ''};
    },

    // 取消编辑（ESC键）
    handleCancelEdit() {
      if (this.editing.rowIndex > -1) {
        const {rowIndex, column, originalValue} = this.editing;
        this.tableData[rowIndex][column] = originalValue;
      }
      this.editing = {rowIndex: -1, column: ''};
    },

    // 批量保存所有修改
    async handleBatchSave() {
      try {
        const changedData = this.tableData
            .map((row, index) => ({
              current: row,
              original: this.originalData[index]
            }))
            .filter(({current, original}) =>
                current.roi3 !== original.roi3 ||
                current.roi7 !== original.roi7 ||
                current.roi15 !== original.roi15 ||
                current.roi30 !== original.roi30 ||
                current.roi45 !== original.roi45 ||
                current.roi60 !== original.roi60 ||
                current.roi75 !== original.roi75 ||
                current.roi90 !== original.roi90 ||
                current.roi105 !== original.roi105 ||
                current.roi120 !== original.roi120 ||
                current.roi135 !== original.roi135 ||
                current.roi150 !== original.roi150
            )
            .map(({current}) => current);

        if (changedData.length === 0) {
          this.$message.warning('没有需要保存的修改');
          return;
        }
        console.log(changedData)
        // 模拟API调用
        await this.$axios.post('/toufang/data/updateList', changedData);
        // 更新原始数据
        this.originalData = JSON.parse(JSON.stringify(this.tableData));
        this.$message.success(`成功保存 ${changedData.length} 条数据`);
      } catch (error) {
        this.$message.error('保存失败');
      }
    },

    // 高亮正在编辑的单元格
    getCellClassName({rowIndex, columnIndex}) {
      if (
          rowIndex === this.editing.rowIndex &&
          this.getColumnField(columnIndex) === this.editing.column
      ) {

        console.log(this.editing.column)
        return 'editing-cell';
      }
      return '';
    },

    // 获取列对应字段名
    getColumnField(columnIndex) {
      return this.tableData[0] ?
          Object.keys(this.tableData[0])[columnIndex] :
          '';
    }
  }
};
</script>

<style scoped>
.editable-cell {
  min-height: 32px;
  cursor: pointer;
  padding: 4px 0;
}

/deep/ .editing-cell {
  background-color: #ffffff !important;
  position: relative;
}

.editing-cell::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  box-shadow: 0 0 3px 1px #67C23A;
  pointer-events: none;
}

.el-input {
  width: 95%;
}


/deep/ .el-tabs__item {
  font-size: 15px; /* 字体大小 */
  font-family: '思源黑体', sans-serif; /* 字体类型 */
  color: #565454; /* 默认颜色 */
  font-weight: bold; /* 字重 */
}

/* Vue2 兼容写法 */
::v-deep .el-tabs__nav {
  font-weight: bold;
}

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.96);

}

/deep/ .el-range-input {
  background-color: rgba(248, 245, 245, 0.94);

}

</style>
